import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Menu, X, ChevronDown, User, HelpingHand } from 'lucide-react';

function Navigation() {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showProjectsSubmenu, setShowProjectsSubmenu] = useState(false);
  const getCurrentPageName = () => {
    const path = location.pathname;
    if (path.startsWith('/np/')) return 'Non-Profit';
    if (path === '/account') return 'Account';
    if (path === '/admin') return 'Admin';
    if (path === '/login') return 'Login';
    if (path === '/register') return 'Register';
    if (path === '/projects') return 'Projects';
    if (path === '/prospecting') return 'Prospecting';
    return '';
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };





  return (
    <nav className="bg-gray-800">
      <div className="max-w-7xl mx-auto pl-2 pr-4">
        <div className="flex justify-between h-16">
          {/* Logo and Brand */}
          <div className="flex items-center">
            <Link to="/" className="text-white text-xl font-bold">
              AiNonProfitCoach
            </Link>
          </div>

          {user ? (
            <>
              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center space-x-4">
                <div className="text-gray-300 text-3xs">
                  {/*user.email} : {getCurrentPageName()*/}
                </div>









                {/* NP Non-profit Menu */}
                <div className="relative group">
                  <Link to="" className="text-white hover:text-gray-300 px-3 py-2 inline-flex items-center">
                    <HelpingHand className="w-4 h-4 mr-1" />
                    NP <ChevronDown className="ml-1 h-4 w-4" />
                  </Link>
                  <div className="absolute left-0 hidden group-hover:block w-64 py-1 bg-white rounded-md shadow-lg z-50">
                    <Link to="/np/secure-np-planner" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        Secure Non-Profit Planner
                      </Link>
                      <Link to="/np/np-economics-planner"  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        Non-Profit Economics Planner
                      </Link>
                    <Link to="/np/nonprofit-security-lead-form" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Secure Non-Profit Lead Form
                    </Link>
                    <Link to="/np/data-product-page" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Secure Non-Profit Data Product Page
                    </Link>
                    <Link to="/np/np-economics-data-product-page" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Non-Profit Economics Data Product Page
                    </Link>

                    <Link to="/np/np-prospecting" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Non-Profit Prospecting
                    </Link>

                    <Link to="/np/impact-products/data-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Data Security
                    </Link>
                    <Link to="/np/impact-products/donor-demographics" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Donor Demographics
                    </Link>
                    <Link to="/np/impact-products/economic-cycles" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Economic Cycles
                    </Link>
                    <Link to="/np/impact-products/economics-utils" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Economics Utils
                    </Link>
                    <Link to="/np/impact-products/email-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Email Security
                    </Link>
                    <Link to="/np/impact-products/file-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      File Security
                    </Link>
                    <Link to="/np/impact-products/financial-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Financial Security
                    </Link>
                    <Link to="/np/impact-products/fundraising-strategies" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Fundraising Strategies
                    </Link>
                    <Link to="/np/impact-products/government-funding" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Government Funding
                    </Link>
                    <Link to="/np/impact-products/information-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Information Security
                    </Link>
                    <Link to="/np/impact-products/operational-security" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Operational Security
                    </Link>
                    <Link to="/np/impact-products/resilience-playbook" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Resilience Playbook
                    </Link>
                    </div>
                </div>

                {/* Account Menu */}
                <div className="relative group">
                  <Link to="/account" className="text-white hover:text-gray-300 px-3 py-2 inline-flex items-center">
                  <User className="w-4 h-4 mr-1" />
                    Account <ChevronDown className="ml-1 h-4 w-4" />
                  </Link>
                  <div className="absolute left-0 hidden group-hover:block w-64 py-1 bg-white rounded-md shadow-lg z-50">
                    <Link to="/account" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Account Settings
                    </Link>

                    <Link to="/subscriptionplans" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Subscription Plans
                    </Link>
                
                    {/*user?.roles?.some(role => role.permissions.includes('admin')) && (*/}

                      <Link to="/admin" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        Admin Panel
                      </Link>
                      <Link to="/role-test" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        Role Test
                      </Link>
    
                      <Link to="/zip-locator-widget" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        Zip Locator Widget
                      </Link>
                      
                      
                     
                   {/*} )*/}
                    <div className="border-t border-gray-100 mt-1 pt-1">
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        Sign Out
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mobile menu button */}
              <div className="md:hidden flex items-center">
                <button
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  className="text-gray-400 hover:text-white p-2"
                >
                  {isMobileMenuOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>
              </div>
            </>
          ) : (
            // Non-authenticated navigation
            <div className="hidden md:flex items-center space-x-4">
              <Link to="/login" className="text-white hover:text-gray-300">
                Sign in
              </Link>
              <Link to="/register" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                Start Free Trial
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && user && (
        <div className="md:hidden bg-gray-800 p-4">
          <div className="space-y-4">
            <div className="text-gray-300 text-3xs">
              {user.email} : {getCurrentPageName()}
            </div>
            
            <div className="flex flex-col space-y-2">

              {/* NP Non-profit Mobile Menu */}
              <div className="relative">
                <button 
                  className="text-white hover:text-gray-300 w-full text-left flex items-center justify-between" 
                  onClick={() => setActiveMenu(activeMenu === 'np' ? null : 'np')}
                >
                  <span className="flex items-center">
                    <HelpingHand className="w-4 h-4 mr-2" />
                    NP
                  </span>
                  <ChevronDown className="w-4 h-4" />
                </button>
                <div className={`mt-2 ml-6 space-y-2 ${activeMenu === 'np' ? 'block' : 'hidden'}`}>
                  <Link to="/np/secure-np-planner" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Secure Non-Profit Planner
                  </Link>
                  <Link to="/np/np-economics-planner" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Non-Profit Economics Planner
                  </Link>
                  <Link to="/np/nonprofit-security-lead-form" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Secure Non-Profit Lead Form
                  </Link>
                  <Link to="/np/cils-lead-form" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    CILs Lead Form
                  </Link>
                  <Link to="/np/cils-women-lead-form" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    CILs Women Lead Form
                  </Link>
                  <Link to="/np/womens-unpaid-labor" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Women's Unpaid Labor
                  </Link>
                  <Link to="/np/ai-women-twin-coach-intro" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Women Twin Coach Intro 
                  </Link>
                  
                  <Link to="/np/data-product-page" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Secure Non-Profit Data Product Page
                  </Link>
                  <Link to="/np/np-economics-data-product-page" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Non-Profit Economics Data Product Page
                  </Link>
                  <Link to="/np/np-prospecting" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Non-Profit Prospecting
                  </Link>
                </div>
              </div>

              {/* Account Mobile Menu */}
              <div className="relative">
                <button 
                  className="text-white hover:text-gray-300 w-full text-left flex items-center justify-between" 
                  onClick={() => setActiveMenu(activeMenu === 'account' ? null : 'account')}
                >
                  <span className="flex items-center">
                    <User className="w-4 h-4 mr-2" />
                    Account
                  </span>
                  <ChevronDown className="w-4 h-4" />
                </button>
                <div className={`mt-2 ml-6 space-y-2 ${activeMenu === 'account' ? 'block' : 'hidden'}`}>
                  <Link to="/account" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Account Settings
                  </Link>
                  <Link to="/subscriptionplans" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Subscription Plans
                  </Link>
                  <Link to="/admin" className="block px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm">
                    Admin Panel
                  </Link>
          
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-3 py-2 text-white hover:bg-gray-700 rounded pl-6 text-sm"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;